import script from "./paperResourceIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./paperResourceIndex.vue?vue&type=script&lang=ts&setup=true"

import "./paperResourceIndex.vue?vue&type=style&index=0&id=188259a6&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188259a6"]])

export default __exports__